import { UserModel } from "../../user/_models/user.model";

export class RoomModel {
  id: number;
  name: string;
  number_room: string;
  description: string;
  active: string;
  functionary: any;
  space: any;
}
